export default async function init() {
  const elements = document.querySelectorAll('.search');

  const { default: Search } = await import(/* webpackChunkName: "search" */ './search');

  elements.forEach((element) => new Search(element));
}
